import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "side-menu-field-descr text-truncate"
}
const _hoisted_2 = { class: "field-input" }

import {__} from "~/ts/library/Translate";
import SideMenuCardSection from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCardSection.vue";
import ClientFieldsList from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/fields/ClientFieldsList.vue";
import ClientTags from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/fields/ClientTags.vue";
import {computed, ref} from "vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import Delay from "~/ts/library/Delay";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import siteQuestionCategoriesToTreeData from "~/operatorApplication/ts/service/dialog/siteQuestionCategoriesToTreeData";
import MyTreeSelect from "~/core-ui/vue/ui/tree-select/MyTreeSelect.vue";

import OperatorApplicationDialogOpenApiModel = OperatorApplicationApi.OperatorApplicationDialogOpenApiModel;
import OperatorApplicationClientOpenApiModel = OperatorApplicationApi.OperatorApplicationClientOpenApiModel;
import OperatorGetParamsSiteOpenApiModel = OperatorApplicationApi.OperatorGetParamsSiteOpenApiModel;

import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "DialogDataCardSections"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    dialog: {},
    userdata: {},
    site: {}
  },
  setup(__props: any) {

let props = __props;

let canEdit = computed(() => {
    return OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canEditClientInfo, props.userdata.siteId);
});


async function onQuestionCategoryChange(questionCategory: string) {
    try {
        await Delay.make(1000, `questionCategoryChange`, true);
        let p: OperatorApplicationApi.OperatorMessageSetQuestionCategoryOpenApiModel = {
            username: props.userdata.username,
            dialogId: props.dialog.id,
            questionCategory: questionCategory ?? ""
        };
        let result = await (new OperatorApiRequest({
            url: "/message/setQuestionCategory",
            p,
            silent: true
        })).send();

        result.showMessageOnError();
    } catch (e) {

    }
}

async function sendUpdateDialogTagsRequest(p: OperatorApplicationApi.OperatorMessageSetDialogTagsOpenApiModel) {
    return await (new OperatorApiRequest({
        url: "/message/setDialogTags",
        p,
        silent: true
    })).send();
}

let localTags = ref<string[]>();

async function onDialogTagsChange(tags: string[]) {
    try {
        let dialog = props.dialog;
        if (dialog) {
            dialog.tags = localTags.value = tags;
            await Delay.make(3000, `dialogTagsChange`, true);
            let p: OperatorApplicationApi.OperatorMessageSetDialogTagsOpenApiModel = {
                username: props.userdata.username,
                dialogId: dialog.id,
                tags: dialog.tags
            };
            let requestResult = await sendUpdateDialogTagsRequest(p);
            requestResult.showMessageOnError();
            if (JSON.stringify(localTags.value) === JSON.stringify(tags)) {
                localTags.value = undefined;
            }
        }
    } catch (e) {
        if (JSON.stringify(localTags.value) === JSON.stringify(tags)) {
            localTags.value = undefined;
        }
    }
}

async function sendUpdateDialogInfoRequest(p: OperatorApplicationApi.OperatorUpdateDialogOpenApiModel) {
    return await (new OperatorApiRequest({
        url: "/message/updateDialog",
        p,
        silent: true
    })).send()
}

let questionCategoryTreeData = computed(() => {
    return siteQuestionCategoriesToTreeData(props.site);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.dialog.questionCategory || _unref(questionCategoryTreeData))
      ? (_openBlock(), _createBlock(SideMenuCardSection, {
          key: 0,
          class: "operator-side-menu-field",
          compact: ""
        }, {
          default: _withCtx(() => [
            (__props.dialog.questionCategory)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(__)('Категория вопроса')), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(MyTreeSelect, {
                modelValue: __props.dialog.questionCategory,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((__props.dialog.questionCategory) = $event)),
                  onQuestionCategoryChange
                ],
                placeholder: _unref(__)('Категория вопроса'),
                data: _unref(questionCategoryTreeData),
                disabled: !_unref(canEdit),
                clearable: _unref(canEdit)
              }, null, 8, ["modelValue", "placeholder", "data", "disabled", "clearable"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(ClientTags, {
      descr: _unref(__)('Тэги диалога'),
      "can-edit": _unref(canEdit),
      "model-value": _unref(localTags) ?? __props.dialog.tags,
      tags: __props.site.dialogTags,
      "onUpdate:modelValue": onDialogTagsChange
    }, null, 8, ["descr", "can-edit", "model-value", "tags"]),
    _createVNode(ClientFieldsList, {
      userdata: __props.userdata,
      "field-values": __props.dialog.fields,
      fields: __props.site.dialogFields,
      "show-icons": false,
      "show-titles": true,
      links: __props.dialog.fieldLinks,
      "is-custom": "",
      "send-update-request": (fields) => sendUpdateDialogInfoRequest({username: _unref(props).userdata.username, dialogId: _unref(props).dialog.id, fields})
    }, null, 8, ["userdata", "field-values", "fields", "links", "send-update-request"])
  ], 64))
}
}

})